import { useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import { VOLUNTARY } from 'constants/languageConstants';
import styles from './voluntaryPlanTag.module.less';
import { ReactComponent as VoluntaryIcon } from './voluntaryLogo.svg';

export const VoluntaryPlanTag = () => {
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div className={styles.voluntaryPlanTagWrapper}>
      <span className={styles.voluntaryIcon}>
        <VoluntaryIcon />
      </span>
      <span>{getText(VOLUNTARY, language)}</span>
    </div>
  );
};
